import { CloseButton } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { useEsriMapStore } from '../../hooks/use-esri-map-store';

export const CloseMapLedgerAndClearSelectedEntityButton = observer(
    function CloseMapLedgerAndClearSelectedEntityButton(): React.ReactElement {
        const mapStore = useEsriMapStore();

        const clearSelectedEntity = () => {
            mapStore.clearSelectedMapLedgerEntity();
            mapStore.setIsFollowModeEnabled(false);
        };

        return (
            <CloseButton
                aria-label="close"
                size="sm"
                onClick={clearSelectedEntity}
                data-testid="MAP_CLEAR_SELECTED_ENTITY_BUTTON"
            />
        );
    }
);
